module.exports = __webpack_public_path__ + "img/sticker.de1bbdf8.png";